import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputMask from 'react-input-mask';
import Button from '../common/Button'; // Botão genérico

function InserirEvento({
  pacientes,
  novoEvento,
  onInputChange,
  onPacienteSelect,
  onAdicionarEvento,
}) {
  return (
    <div>
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="input-group">
            <label
              htmlFor="tipo"
              className="block text-md font-medium text-gray-700 mb-2"
            >
              Tipo:
            </label>
            <select
              id="tipo"
              name="tipo"
              value={novoEvento.tipo}
              onChange={onInputChange}
              aria-required="true"
              className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
              aria-label="Selecionar tipo de evento"
            >
              <option value="Consulta">Consulta</option>
              <option value="Teleconsulta">Teleconsulta</option>
              <option value="Cirurgia">Cirurgia</option>
              <option value="Plantão">Plantão</option>
              <option value="Reunião">Reunião</option>
            </select>
          </div>

          <div className="input-group">
            <label
              htmlFor="descricao"
              className="block text-md font-medium text-gray-700 mb-2"
            >
              Descrição:
            </label>
            <input
              type="text"
              id="descricao"
              name="descricao"
              placeholder="Descrição do Evento"
              value={novoEvento.descricao}
              onChange={onInputChange}
              aria-required="true"
              aria-describedby="descricao-help"
              className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div className="input-group">
            <label
              htmlFor="data"
              className="block text-md font-medium text-gray-700 mb-2"
            >
              Data:
            </label>
            <input
              type="date"
              id="data"
              name="data"
              value={novoEvento.data}
              onChange={onInputChange}
              aria-required="true"
              aria-describedby="data-help"
              className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
            />
          </div>

          <div className="input-group">
            <label
              htmlFor="hora"
              className="block text-md font-medium text-gray-700 mb-2"
            >
              Hora:
            </label>
            <input
              type="time"
              id="hora"
              name="hora"
              value={novoEvento.hora}
              onChange={onInputChange}
              aria-required="true"
              aria-describedby="hora-help"
              className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
            />
          </div>
        </div>

        {novoEvento.tipo === 'Teleconsulta' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <div className="input-group">
              <label
                htmlFor="nomePaciente"
                className="block text-md font-medium text-gray-700 mb-2"
              >
                Nome do Paciente:
              </label>
              <Autocomplete
                freeSolo
                id="nomePaciente"
                options={pacientes.map((p) => p.nome)}
                value={novoEvento.nomePaciente}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    onPacienteSelect(event, newValue); // Valor digitado manualmente
                  } else if (newValue && newValue.nome) {
                    onPacienteSelect(event, newValue.nome); // Paciente selecionado
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Nome do Paciente"
                    variant="outlined"
                    required
                    aria-label="Nome do Paciente"
                    className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    onChange={(e) => onPacienteSelect(e, e.target.value)} // Capturar o valor digitado manualmente
                  />
                )}
              />
            </div>

            <div className="input-group">
              <label
                htmlFor="emailPaciente"
                className="block text-md font-medium text-gray-700 mb-2"
              >
                Email do Paciente:
              </label>
              <input
                type="email"
                id="emailPaciente"
                name="emailPaciente"
                placeholder="Email do Paciente"
                value={novoEvento.emailPaciente || ''}
                onChange={onInputChange}
                required
                aria-label="Email do Paciente"
                className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
              />
            </div>

            <div className="input-group">
              <label
                htmlFor="telefonePaciente"
                className="block text-md font-medium text-gray-700 mb-2"
              >
                Telefone/WhatsApp:
              </label>
              <InputMask
                mask="(99) 99999-9999"
                value={novoEvento.telefonePaciente || ''}
                onChange={onInputChange}
                aria-label="Telefone ou WhatsApp do Paciente"
              >
                {(inputProps) => (
                  <input
                    {...inputProps}
                    type="tel"
                    id="telefonePaciente"
                    name="telefonePaciente"
                    placeholder="Telefone/WhatsApp do Paciente"
                    required
                    className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                  />
                )}
              </InputMask>
            </div>
          </div>
        )}

        {/* Botão de Adicionar com acessibilidade */}
        <Button
          type="salvar"
          label="Adicionar"
          onClick={onAdicionarEvento}
          className="mt-6 bg-primary text-white py-3 rounded-md shadow-lg hover:bg-secondary transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          ariaLabel="Adicionar evento à agenda"
        />
      </div>
    </div>
  );
}

InserirEvento.propTypes = {
  pacientes: PropTypes.arrayOf(
    PropTypes.shape({
      nome: PropTypes.string.isRequired,
    })
  ).isRequired,
  novoEvento: PropTypes.shape({
    tipo: PropTypes.string.isRequired,
    descricao: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    hora: PropTypes.string.isRequired,
    nomePaciente: PropTypes.string,
    emailPaciente: PropTypes.string,
    telefonePaciente: PropTypes.string,
  }).isRequired,
  onInputChange: PropTypes.func.isRequired,
  onPacienteSelect: PropTypes.func.isRequired,
  onAdicionarEvento: PropTypes.func.isRequired,
};

export default InserirEvento;
